import { useTranslation } from 'react-i18next';
import { toLocaleString } from '../../lib/currency-helpers.ts';
import { useResolvedLocale } from '../../lib/hooks/locale.ts';
import SmallSpinner from '../ui/small-spinner.tsx';

type Props = {
    loading: boolean;
    count?: number;
};

export function TableFooterWithCount({ loading, count }: Props) {
    const { t } = useTranslation();
    const locale = useResolvedLocale();

    return (
        <div className="my-2 flex w-full flex-row items-center justify-start">
            <div className="font-base flex flex-1 text-left text-sm leading-3">
                {!Number.isNaN(count) && !loading ? (
                    <span className="mr-1">{toLocaleString(Number(count), locale)}</span>
                ) : (
                    <div className="mr-1 flex items-center justify-center">
                        <SmallSpinner />
                    </div>
                )}
                {count === 1 ? t('table_count_results_singular') : t('table_count_results_plural')}
            </div>
        </div>
    );
}
